exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".textArea__wrapper___1x1nE {\n  color: #000000;\n  font-size: 15px;\n  font-weight: normal;\n  line-height: 1.65; }\n  .textArea__wrapper___1x1nE .textArea__title___20Cda {\n    line-height: 2.19;\n    font-size: 16px;\n    font-weight: 800; }\n  .textArea__wrapper___1x1nE .textArea__text___29b0i {\n    display: block;\n    overflow-wrap: anywhere; }\n", ""]);

// exports
exports.locals = {
	"wrapper": "textArea__wrapper___1x1nE",
	"title": "textArea__title___20Cda",
	"text": "textArea__text___29b0i"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/DetailsSection/GroupData/TextArea/textArea.scss
// module id = 4404
// module chunks = 6